import { render } from "./FElectronicaView.vue?vue&type=template&id=65df03a9"
import script from "./FElectronicaView.vue?vue&type=script&lang=js"
export * from "./FElectronicaView.vue?vue&type=script&lang=js"

import "./FElectronicaView.vue?vue&type=style&index=0&id=65df03a9&scope=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__